// src/components/Modal.jsx
import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import "../styles/components/Modal.css";
import ContactFormSimple from "./ContactFormSimple";

export default function Modal({ open, onClose, title = "Get Started", children }) {
  const dialogRef = useRef(null);
  const lastActiveEl = useRef(null);

  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    lastActiveEl.current = document.activeElement;

    const t = setTimeout(() => dialogRef.current?.focus(), 0);

    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
      if (e.key === "Tab" && dialogRef.current) {
        const focusables = dialogRef.current.querySelectorAll(
          'a[href],button:not([disabled]),textarea,input,select,[tabindex]:not([tabindex="-1"])'
        );
        if (!focusables.length) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    };

    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener("keydown", onKey);
      clearTimeout(t);
      lastActiveEl.current?.focus?.();
    };
  }, [open, onClose]);

  if (!open) return null;
  const onBackdrop = (e) => { if (e.target === e.currentTarget) onClose?.(); };

  return createPortal(
    <div className="modal__backdrop" onMouseDown={onBackdrop}>
      <div className="modal" role="dialog" aria-modal="true" aria-labelledby="modal-title" ref={dialogRef} tabIndex={-1}>
        <header className="modal__header">
          <h2 id="modal-title" className="modal__title">{title}</h2>
          <button className="modal__close" aria-label="Close modal" onClick={onClose}>✕</button>
        </header>
        <div className="modal__body">
          {children ?? <ContactFormSimple onSuccess={onClose} />}
        </div>
      </div>
    </div>,
    document.body
  );
}
